import { inject, Injectable } from '@angular/core';
import {
  IxNgHtmlUtilsService,
  IxNgMenuService,
  IxNgPipeService,
  IxNgTopbarService,
} from 'ix-ng-components';
import { BaseAppService } from 'arsktrp-shared-components';

@Injectable({
  providedIn: 'root',
})
export class AppService extends BaseAppService {
  public ixNgHtmlUtilsService = inject(IxNgHtmlUtilsService);
  public ixNgTopbarService = inject(IxNgTopbarService);
  ixNgMenuService = inject(IxNgMenuService);
  ixNgPipeService = inject(IxNgPipeService);

  public prikaziNotification = false;
  public aplikacijaOznaka = 'EVT';
  public appTitle = 'ekmetijstvo';

  private _izvoziLabel = 'Izvozi v Excel';
  private _izvoziIcon = 'fas fa-file-excel';

  static readonly baseAppRole: string = 'EVT_USER';

  public get baseAppRole(): string {
    return AppService.baseAppRole;
  }

  public get izvoziIcon() {
    return this._izvoziIcon;
  }

  public get izvoziLabel() {
    return this._izvoziLabel;
  }

  constructor() {
    super();

    this.version = '1.111.0.0.0';
    this.ixNgPipeService.ixUndefinedPipeValue = '<ni podatka>';
  }

  onTopbarMenuClick() {
    this.ixNgHtmlUtilsService.onTopbarMenuClick();
    this.ixNgTopbarService.topbarMenuActive = false;
  }

  public innerHeight(offset?: number, min?: number): number {
    return Math.max(window.innerHeight - (offset ? offset : 0), min ? min : 0);
  }
}
